import React from 'react';
import { GridCellFormatterCommonProps } from '../../../../../../components/grid/shared/interfaces/gridCellFormatter';
import CustomCellFormatterWrapper from '../../../../../../components/grid/shared/components/formatters/cell/CustomCellFormatterWrapper';
import { useClassName } from '../../../../../../hooks/useClassName';
import { EstSalesCellBlock } from './EstSalesCellBem';
import Tooltip from '../../../../../../components/tooltip/Tooltip';
import { profileMobileBreakpoints } from '../../../../../../../company/components/profile/shared/constants/profileMobileBreakpoints';
import useBreakpointAvailable from '../../../../../../effects/useBreakpointAvailable';

type Props = GridCellFormatterCommonProps;

const EstSalesCell: React.FC<Props> = props => {
  const cn = useClassName(EstSalesCellBlock.Root);
  const isMobile = useBreakpointAvailable(profileMobileBreakpoints);

  const EstSalesSource = props.data.estSalesSource;

  return (
    <CustomCellFormatterWrapper className={cn()} value={props.valueFormatted}>
      {EstSalesSource && !isMobile ? (
        <Tooltip
          className={cn()}
          isTitleHighlighted
          isUnderFixed={true}
          content={`Source: ` + props.data.estSalesSourceVisible}
          title={props.valueFormatted}
        />
      ) : (
        props.valueFormatted
      )}
    </CustomCellFormatterWrapper>
  );
};

export default EstSalesCell;
export {};
